const module = { name: 'shared/global/disqus', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context: { config, movieDetails } } = Fandango_context;


import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';

function onFail(err) {
    return debugLog.error(module.name, 'API failure', err);
}
function onDone() {
    if (!window.DISQUS) {
        return;
    }
    window.DISQUS.reset({
        reload: true,
        config() {
            let topicId = config.discus.identifier || 'default';
            if (movieDetails && movieDetails.id) {
                topicId = 'mid' + movieDetails.id;
            }
            this.page.identifier = topicId;
            this.page.shortname = config.discus.shortname;
            this.page.url = window.location.href.replace(/\?.+$/, '');
            this.page.title = document.title;
        }
    });
}
function init() {
    if (!config.discus) {
        return;
    }
    xhr.ajax({
        url: links.disqus({ shortname: config.discus.shortname }),
        dataType: 'script',
        method: 'GET',
    })
        .done(onDone)
        .fail(onFail);
}
module.exports = {
    init,
};
export default module.exports;